import apiService from './api.service';

export type NotificationType =
  | 'LEVEL_UP'
  | 'ACHIEVEMENT'
  | 'TRAIL_COMPLETED'
  | 'QUIZ_PASSED'
  | 'GAME_WON'
  | 'STREAK_MILESTONE'
  | 'RANKING_CHANGE'
  | 'MISSION_COMPLETED'
  | 'NEW_CONTENT'
  | 'SYSTEM';

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  icon: string | null;
  is_read: boolean;
  read_at: string | null;
  action_url: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

class NotificationsService {
  /**
   * Lista todas as notificações do usuário
   */
  async getNotifications(): Promise<Notification[]> {
    const response = await apiService.get<{ results: Notification[] } | Notification[]>('/notifications/');
    const data = response.data;
    return Array.isArray(data) ? data : data.results;
  }

  /**
   * Marca uma notificação como lida
   */
  async markAsRead(notificationId: string): Promise<void> {
    await apiService.put(`/notifications/${notificationId}/read/`);
  }

  /**
   * Marca todas as notificações como lidas
   */
  async markAllAsRead(): Promise<void> {
    await apiService.put('/notifications/read_all/');
  }

  /**
   * Deleta uma notificação
   */
  async deleteNotification(notificationId: string): Promise<void> {
    await apiService.delete(`/notifications/${notificationId}/`);
  }

  /**
   * Obtém contagem de notificações não lidas
   */
  async getUnreadCount(): Promise<number> {
    const response = await apiService.get<{ count: number }>('/notifications/unread_count/');
    return response.data.count;
  }
}

export const notificationsService = new NotificationsService();
